class AssortedProduct extends HTMLElement {
  constructor() {
    super();

    this.$productForm = this.querySelector('product-form');
    this.$availabilityBadge = this.querySelector('cinq-availability');
    this.buttons = this.querySelectorAll('button[name="variant"]');
    this.images = this.querySelectorAll('[id^="assorted-product-image"]');
    this.addToCartLabel =
      this.$productForm?.querySelector('[type="submit"] span:nth-child(2)')?.textContent.trim() || '';

    if (!this.$productForm) {
      return;
    }

    this.buttons.forEach(($button) => {
      $button.addEventListener('click', (event) => this.handleClick(event));
    });

    this.$availabilityBadge?.addEventListener('cinq-availability:updated', () => {
      this.syncAddButtonState();
    });

    this.syncAddButtonState();
  }

  getActiveSwatch() {
    return this.querySelector('button[name="variant"][aria-current="true"]');
  }

  isAvailable() {
    if (this.$availabilityBadge?.dataset.available !== undefined) {
      return this.$availabilityBadge.dataset.available === 'true';
    }

    const activeSwatch = this.getActiveSwatch();

    if (activeSwatch) {
      return activeSwatch.dataset.variantAvailable !== 'false';
    }

    return this.getAttribute('data-variant-available') !== 'false';
  }

  syncAddButtonState() {
    if (!this.$productForm) {
      return;
    }

    const isAvailable = this.isAvailable();
    const $input = this.$productForm.variantIdInput;
    const $buttonText = this.$productForm.querySelector('[type="submit"] span:nth-child(2)');

    if (isAvailable) {
      if ($input) {
        $input.removeAttribute('disabled');
      }

      this.$productForm.toggleSubmitButton(false);

      if ($buttonText && this.addToCartLabel) {
        $buttonText.textContent = this.addToCartLabel;
      }
    } else {
      if ($input) {
        $input.disabled = true;
      }

      this.$productForm.toggleSubmitButton(true, window.variantStrings?.soldOut);
    }
  }

  handleClick(event) {
    const target = event.currentTarget;
    this.buttons.forEach(($b) => $b.setAttribute('aria-current', 'false'));
    target.setAttribute('aria-current', 'true');

    const { variantId } = target.dataset;
    const imageId = target.getAttribute('aria-controls')?.trim().split(' ')[0] || '';

    if (this.$productForm.variantIdInput) {
      this.$productForm.variantIdInput.value = variantId;
    }

    if (this.$availabilityBadge) {
      this.$availabilityBadge.dataset.variantId = variantId;
      this.$availabilityBadge.check();
    }
    this.syncAddButtonState();

    if (imageId && this.images.length) {
      this.images.forEach(($image) => $image.setAttribute('aria-hidden', 'true'));
      const $image = this.querySelector(`[id="${imageId}"]`);
      if ($image) {
        $image.setAttribute('aria-hidden', 'false');
      }
    }
  }
}

customElements.define('assorted-product', AssortedProduct);
